var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 32,
    viewBox: "0 0 119 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.717,
    y: 21.8211,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 27.717 21.8211)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6023,
    y: 25.5592,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 24.6023 25.5592)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.417,
    y: 27.962,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 20.417 27.962)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6448,
    y: 28.8018,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 15.6448 28.8018)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8784,
    y: 27.962,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 10.8784 27.962)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.67944,
    y: 25.5592,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 6.67944 25.5592)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.57056,
    y: 21.8211,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 3.57056 21.8211)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.91309,
    y: 17.3319,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 1.91309 17.3319)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1.91309,
    y: 12.4557,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 1.91309 12.4557)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 3.57251,
    y: 7.89938,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 3.57251 7.89938)",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 6.68237,
    y: 4.20074,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 6.68237 4.20074)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8784,
    y: 1.78232,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 10.8784 1.78232)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6433,
    y: 0.922058,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 15.6433 0.922058)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20.417,
    y: 1.78232,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 20.417 1.78232)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6069,
    y: 4.20074,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 24.6069 4.20074)",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 27.717,
    y: 7.89938,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 27.717 7.89938)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3704,
    y: 12.4557,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 29.3704 12.4557)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3704,
    y: 17.3319,
    width: 1.94657,
    height: 1.94657,
    rx: 0.973283,
    transform: "rotate(30 29.3704 17.3319)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 7.18604,
    y: 11.8353,
    width: 2.10878,
    height: 8.47246,
    rx: 1.05439,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1948,
    y: 8.57733,
    width: 2.10878,
    height: 14.9423,
    rx: 1.05439,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6643,
    y: 10.7187,
    width: 2.10878,
    height: 10.7831,
    rx: 1.05439,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1309,
    y: 14.0892,
    width: 2.10878,
    height: 4.15921,
    rx: 1.05439,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1948,
    y: 5.46851,
    width: 2.10878,
    height: 21.4122,
    rx: 1.05439,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3922 8.3569C61.2978 8.45975 60.3097 8.72373 59.4349 9.14884C57.749 9.96477 56.7006 11.2435 56.3854 12.8754C56.3217 13.1976 56.3181 13.4445 56.3181 16.8179V20.4176L56.3996 20.7776C56.6687 21.9534 57.239 22.8688 58.1705 23.623C59.1692 24.4321 60.4691 24.9566 62.0203 25.1726C62.4879 25.2377 63.7275 25.2275 64.2375 25.1555C66.0509 24.8949 67.6624 24.1133 68.6363 23.0231C69.3624 22.2106 69.7626 21.2884 69.8653 20.181C69.8937 19.8965 69.9007 18.7274 69.8901 16.4922C69.876 12.8925 69.883 13.0296 69.6493 12.2994C69.2739 11.1201 68.4593 10.143 67.2621 9.42995C66.359 8.89171 65.0308 8.47689 63.8479 8.36719C63.5079 8.33633 62.6756 8.32948 62.3922 8.3569ZM64.0037 11.8263C64.7546 12.0149 65.3567 12.4571 65.6436 13.0296C65.9304 13.5987 65.9163 13.393 65.9163 16.7836C65.9163 19.5537 65.9127 19.8176 65.8525 20.0233C65.5338 21.1787 64.5137 21.8403 63.0616 21.8403C61.6095 21.8403 60.6355 21.1718 60.3132 20.0576C60.253 19.8485 60.2495 19.6291 60.2495 16.7836C60.2495 13.9381 60.253 13.7187 60.3132 13.5096C60.5788 12.5874 61.2837 11.9977 62.3781 11.7783C62.7393 11.7063 63.6318 11.7303 64.0037 11.8263Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1599 8.75329C39.0111 8.82528 38.9297 8.96584 38.9332 9.14411C38.9368 9.26753 39.6168 11.1394 41.7029 16.7617C43.2258 20.862 44.5186 24.2937 44.5752 24.3897C44.6319 24.4857 44.7204 24.6056 44.7771 24.6571C44.9896 24.8559 45.0002 24.8559 46.6719 24.8559C47.6318 24.8559 48.2551 24.8422 48.3401 24.8182C48.5137 24.7736 48.6943 24.5954 48.8289 24.3314C49.0166 23.9748 54.4213 9.29496 54.4213 9.14411C54.4213 8.9727 54.3398 8.82528 54.2088 8.76014C54.1132 8.71215 53.8865 8.70872 52.445 8.71558L50.791 8.72586L50.6423 8.80814C50.3306 8.97955 50.5502 8.38646 48.1701 15.4693C47.3909 17.7834 46.7428 19.6655 46.7322 19.6518C46.718 19.6381 45.9246 17.3137 44.9648 14.4854C44.005 11.657 43.1798 9.2641 43.1337 9.16468C43.0275 8.9487 42.8575 8.79442 42.6733 8.74643C42.4679 8.69157 39.2697 8.69843 39.1599 8.75329Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5973 8.82558C73.4804 8.87701 73.4308 8.92501 73.3777 9.03814C73.3104 9.18213 73.3069 9.33297 73.3069 16.8306C73.3069 24.3283 73.3104 24.4791 73.3742 24.6162C73.4238 24.7225 73.4804 24.7774 73.6008 24.8322L73.7602 24.9076L77.1922 24.8939C80.9146 24.8836 80.7871 24.8871 81.6761 24.6848C84.1163 24.1191 85.8376 22.6724 86.3547 20.7526C86.5212 20.1252 86.5247 20.0532 86.5424 17.2797C86.5637 13.872 86.5353 13.3921 86.2555 12.583C85.6428 10.8174 83.879 9.45982 81.5379 8.949C80.6985 8.76387 80.5356 8.75702 77.008 8.75702C73.8559 8.75702 73.7461 8.76045 73.5973 8.82558ZM80.6206 12.2299C81.4458 12.4596 81.9877 12.8538 82.2959 13.4503C82.5721 13.9851 82.5686 13.9269 82.5686 16.8649C82.5686 19.4498 82.5686 19.4738 82.4907 19.7378C82.3525 20.204 82.2144 20.4337 81.8815 20.756C81.5379 21.0885 81.1979 21.2737 80.6914 21.4108C80.4223 21.4862 80.3373 21.4896 78.8249 21.5034L77.2382 21.5136V12.1476L78.8249 12.1579C80.1885 12.1716 80.4364 12.1819 80.6206 12.2299Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4348 8.74579C90.2258 8.78007 90.0983 8.85892 90.0133 9.02005C89.9567 9.12633 89.9531 9.24975 89.9602 10.4634C89.9708 11.7421 89.9744 11.7935 90.0452 11.8827C90.0842 11.9341 90.1621 12.0095 90.2152 12.0472L90.3108 12.1192H102.225L102.353 12.0438C102.431 11.9958 102.505 11.9101 102.548 11.821C102.611 11.6873 102.615 11.581 102.615 10.4222C102.615 9.26346 102.611 9.16404 102.544 9.03719C102.448 8.85549 102.335 8.7835 102.084 8.74236C101.822 8.70122 90.6898 8.70465 90.4348 8.74579Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.656 8.74284C104.554 8.78398 104.433 8.97254 104.433 9.09253C104.433 9.14395 104.451 9.22623 104.469 9.27765C104.49 9.32908 105.542 10.9918 106.806 12.9768L109.108 16.5833L106.834 20.3681C105.584 22.4491 104.539 24.2112 104.515 24.2832C104.454 24.4512 104.504 24.6569 104.635 24.7735L104.727 24.8557H106.427C107.67 24.8557 108.166 24.8455 108.272 24.8146C108.495 24.7495 108.673 24.5438 108.991 23.9815C109.873 22.432 111.396 19.8402 111.428 19.8402C111.449 19.8402 112.062 20.8789 112.792 22.1474C113.599 23.5461 114.176 24.5164 114.261 24.6055C114.495 24.8558 114.47 24.8523 116.397 24.8557H118.111L118.211 24.7598C118.327 24.6466 118.377 24.4478 118.327 24.2935C118.31 24.2352 117.272 22.4765 116.022 20.3853L113.748 16.5833L116.054 12.9528C117.322 10.9575 118.37 9.27765 118.388 9.2228C118.43 9.07881 118.37 8.90054 118.242 8.79769L118.133 8.70856H116.436C114.563 8.70856 114.591 8.70513 114.357 8.92454C114.159 9.10624 113.982 9.37022 112.707 11.3826C112.03 12.4488 111.463 13.3333 111.449 13.347C111.432 13.3642 110.872 12.5208 110.203 11.4786C108.729 9.17824 108.641 9.04796 108.481 8.91083C108.237 8.70513 108.276 8.70856 106.427 8.71199C105.496 8.71199 104.699 8.7257 104.656 8.74284Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.51 15.1605C91.4038 15.2154 91.3329 15.2839 91.2834 15.3765C91.2125 15.5068 91.209 15.5685 91.209 16.7821C91.209 17.9957 91.2125 18.0574 91.2834 18.1877C91.3329 18.2802 91.4038 18.3488 91.51 18.4002L91.6659 18.4791H100.882L101.037 18.4002C101.151 18.3488 101.218 18.2837 101.268 18.1877C101.335 18.0574 101.338 17.982 101.338 16.7992C101.338 15.4073 101.331 15.3559 101.115 15.1948L100.991 15.1022L96.3304 15.0919L91.6694 15.0851L91.51 15.1605Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4106 21.4999C90.2123 21.5376 90.0919 21.6199 90.0139 21.7742C89.9573 21.8804 89.9502 22.021 89.9502 23.166C89.9502 23.982 89.9644 24.4756 89.9892 24.5374C90.0458 24.6848 90.191 24.8116 90.3504 24.8528C90.4602 24.8836 92.0505 24.8905 96.3608 24.8836C102.059 24.8733 102.226 24.8699 102.336 24.8082C102.396 24.7705 102.484 24.6779 102.531 24.6025C102.585 24.5088 102.612 24.0391 102.612 23.1935C102.612 21.9936 102.608 21.9181 102.541 21.7913C102.449 21.6165 102.322 21.5273 102.109 21.493C101.875 21.4553 90.609 21.4622 90.4106 21.4999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.4203a2b1f690ba60b91b9161a7797197.svg";
export { ForwardRef as ReactComponent };